module.exports = __webpack_public_path__ + "static/media/splash.815fc06a.jpg";